import { useAbility } from '@casl/react'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { AbilityContext } from '../../../../../ability/context'
import { Action, Permission } from '../../../../../ability/types'
import { mapTeamMember, unmapTeamMember } from '../../../../../lib/Proxy/NarusTeamMember'
import * as Card from '../../../../shared/card'
import CrudTable from '../../../../shared/CrudTable'
import ConfirmationDeleteDialog from '../../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import { tableDefinition } from './constants'
import NarusTeamForm from './form'

const NarusTeamGread = (props) => {
  const {
    params: { id: patientId },
    practitioners
  } = props

  const users = useSelector(state => state.crudTable?.narusTeams?.entries) || []

  const ability = useAbility(AbilityContext)

  const urls = useMemo(() => ({
    get: () => `/patients/${patientId}/narusCareTeam`,
    create: () => `/patients/${patientId}/narusCareTeam`,
    update: entry =>
      `/patients/${patientId}/narusCareTeam?careMemberId=${entry.id}`,
    delete: entry =>
      `/patients/${patientId}/narusCareTeam?careMemberId=${entry.id}`
  }), [ patientId ])

  const mapFns = useMemo(() => ({
    toForm: entry => unmapTeamMember(entry, practitioners),
    toFhir: entry => mapTeamMember(patientId, entry)
  }), [ patientId, practitioners ])

  return (
    <Card.Card expandable>
      <Card.Header>
        <h2>Care Team Members</h2>
      </Card.Header>
      <Card.ExpandableWrapper
        style={{ padding: '0 1rem 1rem 1rem' }}
      >
        <CrudTable
          entryType='narusTeam'
          entrySet={patientId}
          labelButton='Care Team Member'
          labelNoEntries='Care Team Members'
          tableDefinition={tableDefinition}
          urlFns={urls}
          form={NarusTeamForm}
          additionalFormProps={{ presentUsers: users }}
          mapFns={mapFns}
          deleteDialog={ConfirmationDeleteDialog}
          additionalDeleteDialogProps={{ prompt: 'Really delete?' }}
          sortOn={4}
          sortDir='asc'
          readOnly={ability.cannot(Action.UPDATE, Permission.NARUS_TEAM)}
        />
      </Card.ExpandableWrapper>
    </Card.Card>
  )
}

export default NarusTeamGread
